namespace GeniuzPOS.ReportMasterData {
    export interface Report_1103Form {
        PluDesc: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        SellUnit: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        SupplName: Serenity.StringEditor;
        CatCode: Serenity.LookupEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat1Name: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.LookupEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
        VatType: Serenity.StringEditor;
        VatCode: Serenity.StringEditor;
    }

    export class Report_1103Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1103';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1103Form.init)  {
                Report_1103Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(Report_1103Form, [
                    'PluDesc', w0,
                    'SkuCode', w0,
                    'SellUnit', w0,
                    'SupplierId', w1,
                    'SupplName', w0,
                    'CatCode', w1,
                    'CatName', w0,
                    'SubCat1Code', w1,
                    'SubCat1Name', w0,
                    'BrandCode', w0,
                    'BrandName', w1,
                    'SellUnitPrice1', w2,
                    'SellUnitPrice2', w2,
                    'SellUnitPrice3', w2,
                    'SellUnitPrice4', w2,
                    'SellUnitPrice5', w2,
                    'SellUnitPrice6', w2,
                    'VatType', w0,
                    'VatCode', w0
                ]);
            }
        }
    }
}
